import { CheckCircle } from "lucide-react";

export const BenefitsSection = () => {
  const benefits = [
    {
      title: "Improved Efficiency",
      description: "Automate data flows and eliminate manual data entry, saving time and reducing errors."
    },
    {
      title: "Better Decision Making",
      description: "Access real-time data across all systems for informed business decisions."
    },
    {
      title: "Enhanced Collaboration",
      description: "Enable seamless data sharing between teams and departments."
    },
    {
      title: "Scalable Solutions",
      description: "Easily adapt and scale your data integration as your business grows."
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-4">
            Benefits of Data Integration
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Transform your business operations with our comprehensive data integration solutions
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-8">
          {benefits.map((benefit, index) => (
            <div 
              key={index}
              className="p-6 bg-blue-50 rounded-lg hover:shadow-lg transition-shadow"
            >
              <div className="flex items-start gap-4">
                <CheckCircle className="h-6 w-6 text-blue-600 mt-1 flex-shrink-0" />
                <div>
                  <h3 className="text-xl font-semibold mb-2">{benefit.title}</h3>
                  <p className="text-gray-600">{benefit.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};